/**
 * If either of the values is undefined, it ranks them higher up.
 * Otherwise, it compares the values using built-in localeCompare().
 */
export const safeLocaleCompare = (
  a: string | undefined,
  b: string | undefined
) => {
  if (a === undefined && b === undefined) {
    return 0;
  }

  if (a === undefined) {
    return -1;
  }

  if (b === undefined) {
    return 1;
  }

  return a.localeCompare(b);
};
